<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.managers', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ fullName }}
                        </h3>
                    </div>
                    <b-container>
                    <div class="list-group list-group-flush">

                            <b-row>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.lastName') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.nom) }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.firstName') }}:

                                        <span class="font-weight-bold">
                                {{ mManagerUserInformation.prenom != null ? getValue(mManagerUserInformation.prenom) : " "}}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.email') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.email) }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.phoneNumber') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.telephone) }}
                            </span>
                                    </div>

                                </b-col>

                            </b-row>

                            <b-row>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.civility') }}:

                                        <span class="font-weight-bold">
                                {{ mManager.civilite }}
                            </span>
                                    </div>
                                </b-col>
                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.nationality') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.nationalite) }}
                            </span>
                                    </div>
                                </b-col>

                            </b-row>

                            <b-row>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $tc('message.countries', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.pays) }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $tc('message.cities', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.ville) }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.street') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.quartier) }}
                            </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.zipCode') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.code_postal) }}
                            </span>
                                    </div>
                                </b-col>


                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.address') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mManagerUserInformation.adresse) }}
                            </span>
                                    </div>
                                </b-col>
                            </b-row>

                    </div>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="mManager.isAuthor || hasAdminRole">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updateManager">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>


                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.managers', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ fullName }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteManager">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: "Manager",

        computed: {
            ...mapGetters(["manager",
                'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mManager: function() {
                return this.manager;
            },
            
            mManagerUserInformation:function(){
                if (typeof this.mManager.user == 'object'){
                    return this.mManager.user;
                }
                return [];
            },

            fullName:function () {
                let prenom  = this.mManagerUserInformation.prenom != null ? this.getValue(this.mManagerUserInformation.prenom) : "";
                prenom = prenom.toLowerCase();
                return (this.getValue(this.mManagerUserInformation.nom)).toUpperCase() + " "+prenom.charAt(0).toUpperCase() + prenom.substring(1);
            },


            
        },

        data() {
            return {
                manager_id: this.$route.params.manager
            }
        },

        methods: {
            getManager() {
                let args = {
                    manager: this.manager_id
                };

                this.$store.dispatch("getManager", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateManager() {
                this.$router.push({ name: 'edit-manager', params: { manager: this.manager_id } });
            },

            deleteManager() {
                let self = this;
                let args = {
                    manager: this.manager_id
                };

                let successMessage = this.$i18n.t('message.managerDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteManager', { args, index: self.manager_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },
            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
            }
            }
        },

        mounted() {
            this.getManager();
        }
    }
</script>

<style scoped>

</style>